import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const Sair = () => {
  return <div>Realizando logout...</div>;
};

export default Sair;
